import React, { useState, useEffect } from "react";
import "../styles/SetPassword.css"; // Assuming you have a CSS file for styles
import Axios from '../utils/Axios';
import { Link, useLocation } from "react-router-dom";
import validateForm from '../utils/Validation';
import AuthHandler from '../utils/AuthHandler';
import { RESET_TO_NEW_PASSWORD, VALIDATE_RESET_TOKEN } from "../config/API_Collection";

function SetPassword() {
 const [showForm, setShowForm] = useState(false);
 const [showTokenError, setShowTokenError] = useState(false);
  const [showValidating, setShowValidating] = useState(false);
    const [formErrors, setFormErrors] = useState({});

    const [validatingText, setValidatingText] = useState("");
const [TokenErrorText, setTokenErrorText] = useState("");

  useEffect(() => {
    // Show password form after 3 seconds
    const timer = setTimeout(() => 
      {
        setShowValidating(true);
        setValidatingText("Validating the request ...");
        setTimeout(() => {
    validateToken();
  }, 1000);
      }
    , 1000);
    
    return () => clearTimeout(timer);
  }, []);


  const validateToken = async () => {
      try {
        localStorage.removeItem('authToken');
        const payload = {
        token: new URLSearchParams(window.location.search).get('plr'),
      };
        const response = await Axios.post(VALIDATE_RESET_TOKEN, payload);
        if (response.status === 200) {
          setShowForm(true);
          setShowValidating(false);
  
        }
      } catch (error) {
        console.error("Error validating token:", error);
        setShowValidating(false);
        setTokenErrorText("Invalid or expired activation request. Please contact support team.");
        setShowTokenError(true);

      } finally {
        
      }
    };

    const handleSetPassword = async (e) => {
    e.preventDefault();

    try {
      const formData = e.target;

      const payload = {
        token: new URLSearchParams(window.location.search).get('plr'),
        new_password: formData.new_password.value,
        cnf_password: formData.cnf_password.value,
      };
      //console.log(payload);
      const requiredFields = ['token', 'new_password', 'cnf_password']; 
      // Validate the form data
      const errors = validateForm(payload, requiredFields);
      setFormErrors(errors);
      if (Object.keys(errors).length > 0) {
        return;
      }
      //setFormErrors({}); // Reset errors before validation

      if (formData.new_password.value !== formData.cnf_password.value) {
        setFormErrors({ cnf_password: 'Passwords do not match' });
        return;
      }

      setShowForm(false);
      setValidatingText("Setting password ...");
      setShowValidating(true);

      const response = await Axios.post(RESET_TO_NEW_PASSWORD, payload,);
      

      if (response.status === 200) {
        
        setValidatingText("Password set successfully. Redirecting to login...");
        //setShowValidating(true);

        setTimeout(() => {
          window.location.href = '/login'; // Redirect to login page after 2 seconds
        }, 4000);
    
        
        
      }
    } catch (error) {
      
      setShowValidating(false);
      setTokenErrorText("An error occurred while setting the password. Please try again.");
      setShowTokenError(true);

    } finally {
      //closeModal();
    }
  };

  return (
    <div className="set-password-container">
      <div className={`header ${showForm ||showValidating || showTokenError   ? "move-top" : ""}`}>
        <Link to="/"><img src="../assets/images/logo.png" alt="Logo" className="logo" /></Link>
        <h2 className="mb-4 text-center fw-lighter text-body-secondary">Welcome to ProjeX</h2>
        
      </div>

      {showForm && (
        <div className="password-form">
            <p className="subtitle">Please set your password to activate your account</p>
          <form className="budget-form" onSubmit={handleSetPassword}>
            <div className={`form-group flex-item ${formErrors.new_password ? 'has-error' : ''}`}>
              <label className="form-label fw-lighter">New Password</label>
              <input className="form-control" type="password" name="new_password" placeholder="Enter new password" />
            </div>
            <div className={`form-group flex-item ${formErrors.cnf_password ? 'has-error' : ''}`}>
              <label className="form-label fw-lighter">Confirm Password</label>
              <input className="form-control" type="password" name="cnf_password" placeholder="Confirm your password" />
            </div>
            <button className="btn btn-primary w-100 mt-3" type="submit">Set Password</button>
          </form>
        </div>
      )}

      {showValidating && (
        <div className="loading-validating">
          <p className="text-center">{validatingText} </p>
          <div className='loading-login'>
            <img className='loading-login-img' src="/assets/images/l2.gif" />
          </div>
        </div>
      )}
      {showTokenError && (
        <div className="error-message">
          <p className="text-center text-danger">{TokenErrorText}</p>
        </div>
      )}
     
    </div>
      
  );
}
export default SetPassword;